export default __webpack_public_path__ + "static/media/interno_4.870cdcb8.jpg";